module.exports = __webpack_public_path__ + "static/media/poster.1c068de4.jpeg";